module.exports = __webpack_public_path__ + "static/media/t-space-logo.2d411e21.svg";